<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <fa-icon matPrefix [icon]="['fas', 'magnifying-glass']" size="sm"></fa-icon>
  <input
    matInput
    [value]="value()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    (input)="updateValue($event)"
  />

  @if (value()) {
    <button matRipple matSuffix class="clear-button" (click)="clear()">
      <fa-icon [icon]="['fas', 'xmark']" size="sm" id="x-mark"></fa-icon>
    </button>
  }
</mat-form-field>
